export default __webpack_public_path__ + "static/media/Suprema-Veneto.376bf970.png";